import { useQuery } from '@tanstack/react-query';
import { devStandardsApi } from '../api/devStandardsApi';

/**
 * GET /api/eraf/standards/{id} — 특정 버전 전문
 * queryKey: ['dev-standards', 'version', id]
 *
 * id 가 undefined / null 이면 쿼리 비활성
 */
export function useStandardsVersion(id: number | null | undefined) {
  return useQuery({
    queryKey: ['dev-standards', 'version', id],
    queryFn: () => devStandardsApi.getVersion(id!),
    enabled: id != null,
    staleTime: 60_000,
  });
}
